import { useMemo, useState } from "react";

export default function useProductSearch(products) {
  const [searchTerm, setSearchTerm] = useState("");

  const categories = useMemo(() => {
    const unique = [...new Set(products.map((p) => p.category))];
    return unique.map((category, i) => ({ id: i, category }));
  }, [products]);

  return { searchTerm, setSearchTerm, categories };
}
